import { gql, useMutation } from '@apollo/client'
import ActionModal from 'components/Dashboard/ActionModal'
import TextInput from 'components/TextInput'
import mutationResponseToToast, { mutationResponseFragment } from './mutationResponseToToast'
import { ChangeOrderEmailMutation, ChangeOrderEmailMutationVariables } from './__generated__/ChangeOrderEmailMutation'

const changeOrderEmailMutation = gql`
  mutation ChangeOrderEmailMutation($input: ChangeOrderEmailInput!) {
    changeOrderEmail(input: $input) {
      order {
        id
        email
      }

      ...MutationResponseFragment
    }
  }

  ${mutationResponseFragment}
`

interface FormValues {
  email: string
  reason: string
  zdRef: string
}

interface ChangeOrderEmailModalProps {
  orderId: string
  initialEmail: string
  onRequestClose: () => void
}

const ChangeOrderEmailModal = ({ orderId, initialEmail, onRequestClose }: ChangeOrderEmailModalProps) => {
  const [changeOrderEmail] = useMutation<ChangeOrderEmailMutation, ChangeOrderEmailMutationVariables>(
    changeOrderEmailMutation
  )

  return (
    <ActionModal<FormValues>
      header="Change Order Email"
      formikInitialValues={{ email: initialEmail, reason: '', zdRef: '' }}
      onSubmit={async (values, { addToast }) => {
        const resp = await changeOrderEmail({
          variables: {
            input: {
              orderId,
              email: values.email,
              reason: values.reason,
              zdRef: values.zdRef,
            },
          },
        })

        if (!resp.data.changeOrderEmail.success) {
          throw new Error(resp.data.changeOrderEmail.message || 'Something went wrong')
        }

        addToast(mutationResponseToToast(resp.data.changeOrderEmail))
      }}
      onRequestClose={onRequestClose}
      submitText="Change Order Email"
    >
      <TextInput name="email" label={`Email (was: "${initialEmail}")`} />
      <TextInput name="reason" label="Reason for change (optional)" />
      <TextInput name="zdRef" label="Zendesk ticket no (if applicable)" />
    </ActionModal>
  )
}

export default ChangeOrderEmailModal
